export type Indexable<T> = { [index: string]: T };

/**
 * TODO: Replace redux state for invoices with zustand if still used
 */
export type RootState = {
  invoices: unknown;
};

export const initialState: RootState = {
  invoices: {
    offices: [],
    gettingOffices: false,
    gettingAssignmentManagerList: false,
    assignmentManagerList: [],
    gettingCommitments: false,
    commitments: [],
    gettingResultStatistics: false,
    resultStatistics: {},
    mode: "invoicereport",
  },
};
